import React, { useEffect } from "react"
import { keycloak } from "../../../lib/keycloak/index.ts"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hook.ts"
import { ButtonComponent } from "../../../ui/molecules/button/index.tsx"
import { SpinnerComponent } from "../../../ui/molecules/spinner/index.tsx"
import { ConfirmModal } from "../../../ui/organisms/confirmModal/index.tsx"
import { ErrorPopup } from "../../../ui/organisms/errorPopup/index.tsx"
import { HeadingSize } from "../../../ui/organisms/heading/dto.ts"
import { HeadingComponent } from "../../../ui/organisms/heading/index.tsx"
import { SuccessPopup } from "../../../ui/organisms/successPopup/index.tsx"
import { financialAdvisorActiveObSubscription } from "../../financialAdvisor/slice.ts"
import { CompanyStatus } from "../dto.ts"
import { findByIdCompany } from "../slice.ts"
import { BankList } from "./list.tsx"
import { findAcubeConnectRequest, findByIdAcubeGetAccount, setAcubeReconnectRequestStatus, setFindAcubeConnectRequestStatus, setOpenAccessBankAccountModal } from "./slice.ts"

export function BankAccount() {
    const dispatch = useAppDispatch()
    const companyState = useAppSelector(state => state.company)
    const bankState = useAppSelector(state => state.bank)
    const authState = useAppSelector(state => state.auth)
    const financialAdvisorState = useAppSelector(state => state.financialAdvisor)

    useEffect(() => {
        if (companyState.findByIdCompanyStatus === 'successfully' && companyState.findByIdCompanyResponse) {
            dispatch(findByIdAcubeGetAccount({ id: companyState.findByIdCompanyResponse !== undefined ? companyState.findByIdCompanyResponse?.id : '', uuid: companyState.findByIdCompanyResponse !== undefined ? companyState.findByIdCompanyResponse?.acubeAccounts : [] }))
            dispatch(financialAdvisorActiveObSubscription(companyState.findByIdCompanyResponse?.financialAdvisor))
        }
    }, [companyState.findByIdCompanyStatus])

    useEffect(() => {
        if (keycloak.hasRealmRole("company")) {
            dispatch(findByIdAcubeGetAccount({ id: authState.findMeCompanyResponse !== undefined ? authState.findMeCompanyResponse?.id : '', uuid: authState.findMeCompanyResponse !== undefined ? authState.findMeCompanyResponse?.acubeAccounts : [] }))
        } else if (keycloak.hasRealmRole("administrative_company")) {
            dispatch(findByIdCompany(authState.findMeReferrersResponse?.company!))
        }
    }, [keycloak.hasRealmRole])

    useEffect(() => {
        if (bankState.findAcubeConnectRequestStatus === 'successfully' && bankState.findAcubeConnectRequestResponse !== undefined) {
            if (!keycloak.hasRealmRole('financial_advisor')) {
                const link = document.createElement('a');
                link.href = bankState.findAcubeConnectRequestResponse
                link.rel = "noreferrer"
                link.target = "_blank"
                link.click();
            }
            const id = setTimeout(() => {
                dispatch(setFindAcubeConnectRequestStatus('idle'))
            }, 3000);
            return () => clearTimeout(id)
        }
    }, [bankState.findAcubeConnectRequestStatus])

    useEffect(() => {
        if (bankState.acubeReconnectRequestStatus === 'successfully' && bankState.acubeReconnectRequestResponse !== undefined) {
            const link = document.createElement('a');
            link.href = bankState.acubeReconnectRequestResponse.reconnectUrl
            link.rel = "noreferrer"
            link.target = "_blank"
            link.click();
            const id = setTimeout(() => {
                dispatch(setAcubeReconnectRequestStatus('idle'))
            }, 3000);
            return () => clearTimeout(id)
        }
    }, [bankState.acubeReconnectRequestStatus])

    if (bankState.findByIdAcubeGetAccountStatus === "loading" || financialAdvisorState.financialAdvisorActiveSubscriptionObStatus === 'loading') {
        return (
            <div className={"flex justify-center items-center flex-grow"}>
                <SpinnerComponent />
            </div>
        )
    }

    return (
        <div className={"flex flex-col gap-3 flex-grow"}>
            <ErrorPopup
                active={bankState.findAcubeConnectRequestStatus === 'failed'}
                close={() => dispatch(setFindAcubeConnectRequestStatus('idle'))}
                message="Si è verificato un errore nella richiesta"
            />
            <ErrorPopup
                active={bankState.acubeReconnectRequestStatus === 'failed'}
                close={() => dispatch(setAcubeReconnectRequestStatus('idle'))}
                message="Si è verificato un errore nella richiesta"
            />
            <SuccessPopup
                active={bankState.acubeReconnectRequestStatus === 'successfully'}
                close={() => dispatch(setAcubeReconnectRequestStatus('idle'))}
                message="Richiesta mandata con successo"
            />
            <SuccessPopup
                active={bankState.findAcubeConnectRequestStatus === 'successfully'}
                close={() => dispatch(setFindAcubeConnectRequestStatus('idle'))}
                message="Richiesta mandata con successo"
            />
            <HeadingComponent
                label={"Conto corrente"}
                buttons={[
                    <>
                        {
                            ((keycloak.hasRealmRole("financial_advisor") || keycloak.hasRealmRole("financial_advisor_collaborator")) &&
                                financialAdvisorState.financialAdvisorActiveSubscriptionObResponse?.openBankingSubscriptionType !== "expired"
                            )
                            &&
                            <ButtonComponent
                                label={"Richiedi accesso"}
                                onClick={() => {
                                    dispatch(setOpenAccessBankAccountModal(true))
                                }}
                                color={"blue"}
                                variant={"solid"}
                                size={"md"}
                                iconPosition="off"
                                disabled={companyState.findByIdCompanyResponse?.status === CompanyStatus.SUSPENDED ||
                                    (!authState.findMeFinancialAdvisorResponse?.isActive && keycloak.hasRealmRole("financial_advisor")) ||
                                    (!authState.findMeCollaboratorResponse?.isActive && keycloak.hasRealmRole("financial_advisor_collaborator"))
                                }
                            />
                        }
                    </>
                ]}
                size={HeadingSize.MD}
            />
            <ConfirmModal open={bankState.openAccessBankAccountModal} handleClose={() => dispatch(setOpenAccessBankAccountModal(false))} title={"Accesso al conto corrente"} description={"Sei sicuro di voler richiedere l'accesso al conto corrente?"}
                labelDeny={"Annulla"} labelConfirm={"Prosegui"} actionConfirm={() => { dispatch(findAcubeConnectRequest(companyState.findByIdCompanyResponse?.id!)); dispatch(setOpenAccessBankAccountModal(false)) }} />
            <BankList />
        </div>
    )
}